import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('fcg_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('fcg_cookie_consent', 'accepted');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 left-6 right-6 md:left-auto md:right-8 md:max-w-md z-[100] animate-in fade-in slide-in-from-bottom-8 duration-700">
      <div className="bg-white/95 backdrop-blur-2xl border border-zinc-200/80 p-8 rounded-[2.5rem] shadow-[0_30px_60px_-15px_rgba(9,9,11,0.15),0_0_40px_rgba(6,182,212,0.08)] relative overflow-hidden group">
        {/* Subtle decorative glow */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-cyan-500/5 blur-[60px] rounded-full group-hover:bg-cyan-500/10 transition-all duration-700" />
        
        <div className="flex items-start gap-6 relative z-10">
          <div className="w-14 h-14 bg-cyan-50/50 border border-cyan-100 flex items-center justify-center flex-shrink-0 rounded-2xl shadow-inner backdrop-blur-md">
            <Shield className="w-7 h-7 text-cyan-600" />
          </div>
          <div className="flex-grow">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-zinc-950 text-base font-display font-bold uppercase tracking-[0.2em]">Security & Privacy</h3>
            </div>
            <p className="text-zinc-500 font-medium leading-relaxed mb-6 text-[11px]">
              We use cookies to enhance your experience and keep the sandbox secure. By continuing, you agree to our 
              <Link to="/privacy-policy" className="text-cyan-600 hover:text-cyan-700 hover:underline transition-colors ml-1 font-semibold">Privacy Policy</Link> and 
              <Link to="/terms-of-service" className="text-cyan-600 hover:text-cyan-700 hover:underline transition-colors ml-1 font-semibold">Terms of Service</Link>.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button 
                onClick={handleAccept}
                className="flex-grow px-8 h-11 bg-cyan-600 hover:bg-cyan-500 text-white font-black uppercase tracking-[0.2em] text-[10px] rounded-xl transition-all active:scale-[0.98] shadow-[0_10px_20px_-5px_rgba(6,182,212,0.3)]"
              >
                Accept All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
